import { createSelector } from 'reselect';
import { IPLUGroupsState, IPLUGroup } from './types';

export const selectSyncState = (state: IPLUGroupsState) => state.syncing;
export const selectPLUGroupSyncing = (state: IPLUGroupsState) => state.pluGroupSyncing;
export const selectLoadedState = (state: IPLUGroupsState) => state.loaded;
export const selectSyncError = (state: IPLUGroupsState) => state.error;

export const selectPLUGroups = (state: IPLUGroupsState) => state.pluGroups;
export const selectPLUGroupItem = (state: IPLUGroupsState) => state.pluGroup;

export const selectCreateInitiatedState = (state: IPLUGroupsState) => state.createInitiated;
export const selectUpdateInitiatedState = (state: IPLUGroupsState) => state.updateInitiated;
export const selectDeleteInitiatedState = (state: IPLUGroupsState) => state.deleteInitiated;

export const selectCreatedState = (state: IPLUGroupsState) => state.pluGroupCreated;
export const selectUpdatedState = (state: IPLUGroupsState) => state.pluGroupUpdated;
export const selectDeletedState = (state: IPLUGroupsState) => state.pluGroupDeleted;

export const selectIndexedPLUGroups = createSelector(selectPLUGroups, (pluGroups) =>
  pluGroups.reduce((indexed: { [key: string]: IPLUGroup }, pluGroup: IPLUGroup) => {
    if (pluGroup.pluGroupId) {
      indexed[pluGroup.pluGroupId] = pluGroup;
    }
    return indexed;
  }, {})
);
export const selectPLUGroup = createSelector(
  [selectIndexedPLUGroups, (_: IPLUGroupsState, id: string) => id],
  (indexedPLUGroups, id) => indexedPLUGroups[id]
);
